export default "__VITE_ASSET__LsEIUrot__"